<template>
    <transition name="el-fade-in-linear">
        <div>
            <headerVue></headerVue>
            <div class="container">
                <div class="top">
                    <div>
                        社员朋友们：
                    </div>
                    <div class="content1">
                        大家好！为进一步提升社省委各项工作水平，更好服务全省广大社员，我们特别在社省委网站开设“主委信箱”，方便大家对社省委工作提出意见建议。
                    </div>
                    <div class="content1">
                        你们提出的意见建议，我会及时查阅、认真研究、客观反馈。
                    </div>
                    <div class="content1">
                        期待大家多提宝贵意见建议！
                    </div>
                    <div style="float: right;margin-bottom: 20px;">
                        <div>高岭</div>
                        <div>2024年2月4日</div>
                    </div>
                </div>
                <el-form v-loading="loading" ref="form" :rules="rules" :model="form" label-width="96px">
                    <el-row :gutter="15">
                        <el-col :span="24">
                            <el-form-item label="标题" prop="title">
                                <el-input v-model="form.title"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="14">
                        <el-col :span="12">
                            <el-form-item label="发件人" prop="sendPeople">
                                <el-input v-model="form.sendPeople"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话" prop="telPhone">
                                <el-input v-model="form.telPhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="正文" prop="desc">
                                <el-input maxlength="1000" show-word-limit :rows="20" type="textarea"
                                    v-model="form.desc"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="验证码" prop="code">
                                <el-input maxlength="4" show-word-limit :rows="20" v-model="form.code"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <img width="120px" style="margin-left: 20px;margin-top: -2px;" :src="codeUrl"
                                @click="getCode" alt="验证码" />
                        </el-col>
                        <el-col :span="4">
                            <!-- <div style="margin-left: -40px;margin-top: 10px;color: red;">验证码输入有误</div> -->
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item style="text-align: center;">
                                <el-button type="primary"
                                    style="background-color: #3282D2;width: 90px;height: 50px;font-size: 18px;"
                                    @click="onSubmit('form')">提交</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- <h2 v-if="this.$route.query.email">
                    主委信箱：{{ this.$route.query.email }}
                </h2> -->
            </div>
            <footerVue></footerVue>
        </div>
    </transition>
</template>

<script>
import headerVue from '../index/header.vue'
import footerVue from '../foot/foot.vue'
export default {
    name: 'Email',
    data() {
        // 自定义验证码的验证规则
        // const sendCode = async (rule, value, callback) => {
        //     let body = '发件人：' + this.form.sendPeople + '\n' + '联系电话：' + this.form.telPhone + '\n' + '-------------------------------------------------------------------------' + '\n' + this.form.desc;

        //     // console.log('rule, value, callback',rule, value, callback);
        //     let res = await this.$api.nav.sendEmail({
        //         subject: this.form.title,
        //         body: body,
        //         code: this.form.code,
        //         uuid: this.uuid
        //     })
        //     console.log('ssssssssssss',res);
        //     if(res.data.code == 200){
        //         callback()
        //     }else{
        //         callback(res.data.code === 200 ? '' : res.data.msg)
        //     }
        // }
        return {
            basicInfo: [],
            form: {
                title: '',
                sendPeople: '',
                telPhone: '',
                desc: '',
                code: ''
            },
            loading: false,
            // 表单校验
            rules: {
                title: [
                    { required: true, message: '请填写标题', trigger: 'blur' },
                    { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
                ],
                sendPeople: [
                    { required: true, message: '请填写发件人名称', trigger: 'blur' },
                    { max: 20, trigger: 'blur' }
                ],
                telPhone: [
                    { required: true, message: '请填写联系电话', trigger: 'blur' },
                    { pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/, message: '号码格式不正确', trigger: 'blur' }
                ],
                desc: [
                    { required: true, message: '请填写联系内容', trigger: 'blur' },
                    { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
                ],
                code: [
                    // { validator: sendCode, trigger: 'blur' },
                    { required: true, message: '请填写验证码', trigger: 'blur' },
                    { min: 1, max: 4, message: '长度在 1 到 4 个字符', trigger: 'blur' }
                ]
            },
            codeUrl: '',
            uuid: ''
        }
    },
    created() {
        this.getCode()
    },
    methods: {
        async getCode() {
            let res = await this.$api.nav.getCode()
            console.log('获取验证码', res);
            this.codeUrl = 'data:image/gif;base64,' + res.data.img
            this.uuid = res.data.uuid
        },
        // 发送邮件
        onSubmit(formName) {
            this.loading = true
            // 表单验证
            this.$refs[formName].validate(async (valid) => {
                // 通过后提交
                if (valid) {
                    console.log('是否通过', valid);
                    console.log('form info', this.form);
                    let body = '发件人：' + this.form.sendPeople + '\n' + '联系电话：' + this.form.telPhone + '\n' + '-------------------------------------------------------------------------' + '\n' + this.form.desc;
                    // console.log('body', body);
                    // 标题：subject
                    // 正文：body

                    let res = await this.$api.nav.sendEmail({
                        subject: this.form.title,
                        body: body,
                        code: this.form.code,
                        uuid: this.uuid
                    })
                    console.log('res', res);
                    if (res.data.code == 200) {
                        this.loading = false

                        this.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定',
                            type: 'success'
                        });
                        this.form = {}
                    } else {
                        this.loading = false
                        this.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定',
                            type: 'error'
                        });
                    }
                } else {
                    this.loading = false
                    return false;
                }
            });
        }
    },
    components: {
        headerVue,
        footerVue
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 1200px;
    margin: auto;
    background-color: white;
    margin-top: 20px;

    .top {
        padding-left: 50px;
        line-height: 35px;
        font-size: 17px;
        .content1{
            text-indent: 2em;
        }
    }

    h2 {
        text-align: center;
        line-height: 450px;
    }

    .title {
        padding: 10px;
        padding-bottom: 20px;
        font-size: 20px;
        text-align: center;
        letter-spacing: 1px;
    }

    .content {
        height: 360px;
        display: flex;
        justify-content: space-between;
        width: 1000px;
        background-color: #3282D2;
        margin: auto;
        margin-bottom: 23px;
        margin-top: 30px;

        .left {
            margin: auto;
            text-align: center;
            line-height: 60px;
            flex: 1;

            p {
                color: white;
                font-size: 13px;
            }
        }

        .right {
            flex: 1;

            img {
                width: 600px;
            }
        }
    }

    .bottom {
        width: 1000px;
        margin: auto;
        text-align: left;

        p {
            font-size: 17px;
            line-height: 35px;
            color: #3C3C3C;
        }

        span {
            color: #999999;
            font-weight: lighter;
            padding: 5px;
        }
    }
}

.transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
}

::v-deep .el-form-item__label {
    font-size: 17px !important;
}
</style>